/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_DescriptionInputs */

const en_settings_tickets_description = /** @type {(inputs: Settings_Tickets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a ticket and our team will get back to you`)
};

const zh_settings_tickets_description = /** @type {(inputs: Settings_Tickets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工单反馈问题,我们会尽快回复你`)
};

/**
* | output |
* | --- |
* | "Submit a ticket and our team will get back to you" |
*
* @param {Settings_Tickets_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_description = /** @type {((inputs?: Settings_Tickets_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_description(inputs)
	return zh_settings_tickets_description(inputs)
});
export { settings_tickets_description as "settings.tickets.description" }